import { z } from "zod";

export const schema = z.object({
	id_whatsapp: z.number().optional(),
	descricao: z.string().min(1, "Descrição é obrigatória"),
	telefone: z.string().optional(),
	data: z.date({
		required_error: "Data de vencimento é obrigatória",
		invalid_type_error: "Data de vencimento inválida",
	}),
	ativo: z.boolean("Campo Ativo é obrigatorio"),
});

export const schemaDefaultValues = {
	id_whatsapp: 0,
	descricao: "",
	telefone: "",
	data: new Date(),
	ativo: true,
};
